
/**
 * [throttle description]
 * \@method throttle
 * @param {?} callback
 * @param {?} delay
 * @return {?}
 */
export function throttle(callback: Function, delay: number): (args: Array<any>) => void {
  let /** @type {?} */ timeout = null;
  return (...args) => {
    if(!timeout) {
      timeout = setTimeout(() => {
        callback.call(this, ...args);
        timeout = null;
      }, delay);
    }
  }
}
